import type { KpiOperator } from '../../lib/kpi';

type Props = {
  operators: KpiOperator[];
  /** Empty = all of them. */
  selected: number[];
  onChange: (selected: number[]) => void;
};

function pillClass(active: boolean): string {
  return [
    'rounded-full px-3 py-1 text-xs font-medium transition-colors',
    active
      ? 'bg-[var(--co-brand)] text-white'
      : 'border border-[var(--co-border)] text-[var(--co-muted)] hover:text-[var(--co-text)]',
  ].join(' ');
}

/** The viewer's own operators only — the list comes from its grant. Picking
 *  every one of them is the same as picking none, so that reads as "All". */
export function OperatorPicker({ operators, selected, onChange }: Props) {
  function toggle(id: number) {
    const next = selected.includes(id) ? selected.filter((one) => one !== id) : [...selected, id];
    onChange(next.length === operators.length ? [] : next);
  }

  return (
    <div
      role="group"
      aria-label="Operators"
      className="flex flex-wrap items-center gap-1.5 rounded-lg border border-[var(--co-border)] bg-[var(--co-surface)] p-3"
    >
      <span className="mr-1 text-sm text-[var(--co-muted)]">Operators</span>
      <button type="button" aria-pressed={selected.length === 0} onClick={() => onChange([])} className={pillClass(selected.length === 0)}>
        All
      </button>
      {operators.map((operator) => (
        <button
          key={operator.id}
          type="button"
          aria-pressed={selected.includes(operator.id)}
          onClick={() => toggle(operator.id)}
          className={pillClass(selected.includes(operator.id))}
        >
          {operator.name}
        </button>
      ))}
    </div>
  );
}
